<template>
    <div class="stream__row" >
            <div class="stream__row__title">
                <div class="stream__row__title__item">{{this.$datef(data.timeExit)}}</div>
                <div class="stream__row__title__item">CLOSE</div>
                <div class="stream__row__title__item">№{{data.id}}</div>
                <div class="stream__row__title__item" 
                    :class="data.side < 0 ? 'color-red': 'color-green'">{{
                            data.side < 0 ? 'SELL' : 'BUY'
                        }}</div>
                <div class="stream__row__title__item">{{data.symbol}}</div>
            </div>
            <div class="stream__row__data">
                <div class="stream__row__data__item">{{`Закрытие позиции №${data.id} (${sellOrBuy(data.side)} ${$moneyf(data.volume)} ${data.symbol})`}}</div>
                <div class="stream__row__data__item">{{`Открытие ${this.$datef(data.timeEnter)} по ${data.priceEnter}`}}</div>
                <div class="stream__row__data__item">{{`Закрытие ${this.$datef(data.timeExit)} по ${data.curPrice}`}}</div>
                <div class="stream__row__data__item">{{`Фин. результат сделки ${data.resultDepo} (${data.resultPoint})`}}</div>
            </div>
        </div>
</template>
<script>
export default {
    data() {
        return {
           
        }
    },
    props: {
        data:{default:{}}
    },
    methods: {
        sellOrBuy(side){
           let type = ''
           if(side < 1)
           type = "SELL"
           else
           type = "BUY" 
           return type
        }
    },
    computed: {
        getNowDate() {
            let date = new Date()
            return this.$datef(date)
        }
    }
}
</script>
<style lang="less" scoped>
.stream__row {
    padding-bottom: 8px;
    border-bottom: 1px solid #374b62;
    color: #adc7e1;
    &__data {
        display: inline-block;
        font-family: Roboto;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.54;
        letter-spacing: normal;
        text-align: left;
        &__item {
            display: inline-block;
            margin-left: 12px;
        }
    }
    &__title {
        display: flex;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.15;
        letter-spacing: 0.4px;
        text-transform: uppercase;
        min-height: 28px;
        color: #ffffff;
        &__item {
            margin-left: 12px;
        }
    }
}
</style>

